import IMask from 'imask';
import Pristine from 'pristinejs';
class FormValidator {
  EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  PHONE_PATTERN = /^\+\d{1,3} \(\d{3}\) \d{3}-\d{2}-\d{2}$/;
  applicationForm;
  phoneInput;
  emailInput;
  privacyPolicyCheckbox;
  pristine;

  init() {
    this.applicationForm = document.querySelector('.application-form');
    this.phoneInput = document.getElementById('phone');
    this.emailInput = document.getElementById('email');
    this.privacyPolicyCheckbox = document.getElementById('privacy-policy');
    this.pristine = new Pristine(
      this.applicationForm,
      {
        classTo: 'pristine-valide',
        errorTextParent: 'pristine-valide',
        errorTextClass: 'pristine-valide--error',
      },
      false
    );
    this.initValidators();
    this.initSubmitListener();
  }

  initValidators() {
    const isValidPhone = (value) => this.PHONE_PATTERN.test(value);
    const isValidEmail = (value) => this.EMAIL_PATTERN.test(value);
    const isChecked = () => this.privacyPolicyCheckbox.checked;

    IMask(this.phoneInput, { mask: '+{7} (000) 000-00-00' });

    this.pristine.addValidator(
      this.phoneInput,
      isValidPhone,
      'Введен неверный формат телефона'
    );
    this.pristine.addValidator(
      this.emailInput,
      isValidEmail,
      'Введен неверный формат почты'
    );
    this.pristine.addValidator(
      this.privacyPolicyCheckbox,
      isChecked,
      'Обязательно примите соглашения'
    );
  }

  initSubmitListener() {
    this.applicationForm.addEventListener('submit', async (event) => {
      event.preventDefault();

      const isValid = this.pristine.validate();
      if (!isValid) {
        return;
      }

      const formData = new FormData(this.applicationForm);

      try {
        const response = await fetch(this.applicationForm.action, {
          method: 'POST',
          body: formData,
        });

        if (response.ok) {
          this.showConfirmation();
        } else {
          console.error('Ошибка при отправке формы');
        }
      } catch (error) {
        console.error('Ошибка сети:', error);
      }
    });
  }

  showConfirmation() {
    const confirmationModal = document.createElement('div');
    confirmationModal.className = 'confirmation-modal';

    const modalContent = document.createElement('div');
    modalContent.className = 'confirmation-modal__content';

    const modalTitle = document.createElement('div');
    modalTitle.className = 'confirmation-modal__title';
    modalTitle.textContent = 'Ваша заявка отправлена';

    const modalText = document.createElement('p');
    modalText.className = 'confirmation-modal__text';
    modalText.textContent =
      'Мы уже получили вашу заявку, и в ближайшее время свяжемся с вами!';

    const closeButtonWrapper = document.createElement('div');
    closeButtonWrapper.className = 'confirmation-modal__btn-wrapper';

    const closeButton = document.createElement('button');
    closeButton.className = 'confirmation-modal__close button';
    closeButton.textContent = 'Закрыть';

    modalContent.appendChild(modalTitle);
    modalContent.appendChild(modalText);
    modalContent.appendChild(closeButtonWrapper);
    closeButtonWrapper.appendChild(closeButton);
    confirmationModal.appendChild(modalContent);

    document.body.appendChild(confirmationModal);

    setTimeout(() => {
      confirmationModal.classList.add('confirmation-modal--visible');
    }, 10);

    closeButton.addEventListener('click', () =>
      this.closeConfirmation(confirmationModal)
    );
    confirmationModal.addEventListener('click', (event) => {
      if (event.target === confirmationModal) {
        this.closeConfirmation(confirmationModal);
      }
    });
  }

  closeConfirmation(modal) {
    modal.classList.remove('confirmation-modal--visible');
    setTimeout(() => {
      document.body.removeChild(modal);
    }, 300);
  }
}

export const formValidator = new FormValidator();
